module.exports = __webpack_public_path__ + "account/assets/tabs-card-arrow-right.d0dfeb90.svg";